// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--mzcKr";
export var mobile = "styles-module--mobile--CyBtw";
export var changeOnMobile = "styles-module--changeOnMobile--IN2VL";
export var backAndForthRight = "styles-module--backAndForthRight--grzAo";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--h5dgJ";
export var animateBg = "styles-module--animateBg--pZihx";